import { IPlayerFlag, IPlayerState } from './IPlayerState';
import DateHelper from '../../Utility/DateHelper';

export function addFlag(state: IPlayerState, id: string): IPlayerState {
    if (!getFlag(state, id)) {
        return {
            ...state,
            flags: [
                ...state.flags,
                {
                    id,
                    date: DateHelper.now().toString(),
                },
            ],
        };
    }
    return state;
}

export function getFlag(state: IPlayerState, id: string): IPlayerFlag {
    return state.flags.find(item => item.id === id);
}

export function isExpiredFlag(
    state: IPlayerState,
    id: string,
    cooldown: number
): boolean {
    const flag = getFlag(state, id);
    return !flag || DateHelper.getElapsedTime(flag.date) > cooldown;
}

export function setFlag(state: IPlayerState, id: string) {
    const flag = getFlag(state, id);
    if (!flag) {
        return {
            ...state,
            flags: [
                ...state.flags,
                {
                    id,
                    date: DateHelper.now().toString(),
                },
            ],
        };
    }
    return {
        ...state,
        // tslint:disable-next-line: no-shadowed-variable
        flags: state.flags.map(flag => {
            if (flag.id === id) {
                return {
                    id: id,
                    date: DateHelper.now().toString(),
                };
            }
            return flag;
        }),
    };
}
